import styled from '@emotion/styled';
import type { FC, ReactNode } from 'react';

import { media } from 'src/styles';
import { Item } from './item';

type Props = {
  className?: string;
  children: ReactNode;
};

export const SubMenuList: FC<Props> & {
  Item: typeof Item;
} = ({ className, children }) => (
  <Wrapper className={className ?? ''}>{children}</Wrapper>
);

const Wrapper = styled.ul`
  list-style: none;
  padding: 0;
  display: grid;
  gap: 1.5em;
  ${media.siteBreakpointOrLess} {
    text-align: center;
  }
`;

SubMenuList.Item = Item;

export default SubMenuList;
